/**
 * Betyget 1–5 på ett ruttförslag. Samma skala och ord i feedbackknappen i ruttplaneringen och i
 * ruttprovet (Ruttfeedback), så att betygen går att jämföra och följa över tid. Orden finns också i
 * morgonmejlet (RoutePlanFeedbackDigestLogic.RatingLabel).
 */
export const RATING_LABELS = [
  '',
  'Dåligt',
  'Svagt',
  'Okej',
  'Bra',
  'Mycket bra',
];
export const MIN_RATING = 1;
export const MAX_RATING = 5;

export const ratingLabel = (rating: number | null | undefined): string =>
  rating ? (RATING_LABELS[rating] ?? '') : '';

/** "★★★☆☆" — för tabeller och listor där knappar vore för mycket. */
export const ratingStars = (rating: number): string =>
  '★'.repeat(Math.max(0, Math.min(MAX_RATING, rating))) +
  '☆'.repeat(MAX_RATING - Math.max(0, Math.min(MAX_RATING, rating)));
